import {anthropicApiKey} from './anthropic-secret';
import {awsAccessKeyId, awsAccountId, awsSecretAccessKey} from './aws-secret';
import {azureClientId, azureClientSecret} from './azure-secret';
import {basicAuthHeader, basicAuthUrl} from './basicauth-secret';
import {envCredential} from './env-credential';
import {
  githubAppToken,
  githubFineGrainedToken,
  githubOAuthToken,
  githubPersonalAccessToken,
  githubRefreshToken,
} from './github-secret';
import {
  googleApiKey,
  googleOAuthToken,
  googleServiceAccountEmail,
  googleServiceAccountKey,
} from './google-secret';
import {jwtToken} from './jwt-token';
import {npmAccessToken, npmAuthToken, npmTokenEnv} from './npm-secret';
import {openaiApiKey} from './openai-secret';
import {
  dsaPrivateKey,
  ecPrivateKey,
  encryptedPrivateKey,
  opensshPrivateKey,
  pgpPrivateKey,
  privateKey,
  rsaPrivateKey,
} from './privatekey-secret';
import {sendgridApiKey} from './sendgrid-secret';
import {shopifyToken} from './shopify-secret';
import {
  slackAppToken,
  slackBotToken,
  slackLegacyToken,
  slackUserToken,
  slackWebhook,
  slackWorkspaceToken,
} from './slack-secret';
import {stripeSecretKey} from './stripe-secret';
import {
  twilioAccountSid,
  twilioApiKeySid,
  twilioAuthToken,
} from './twilio-secret';

export const rules: Record<SecretType, RegExp> = {
  anthropicApiKey,
  awsAccessKeyId,
  awsSecretAccessKey,
  awsAccountId,
  azureClientId,
  azureClientSecret,
  basicAuthUrl,
  basicAuthHeader,
  envCredential,
  githubPersonalAccessToken,
  githubOAuthToken,
  githubAppToken,
  githubRefreshToken,
  githubFineGrainedToken,
  googleApiKey,
  googleOAuthToken,
  googleServiceAccountKey,
  googleServiceAccountEmail,
  jwtToken,
  npmAccessToken,
  npmAuthToken,
  npmTokenEnv,
  openaiApiKey,
  rsaPrivateKey,
  privateKey,
  ecPrivateKey,
  dsaPrivateKey,
  opensshPrivateKey,
  pgpPrivateKey,
  encryptedPrivateKey,
  sendgridApiKey,
  shopifyToken,
  slackBotToken,
  slackUserToken,
  slackWorkspaceToken,
  slackAppToken,
  slackWebhook,
  slackLegacyToken,
  stripeSecretKey,
  twilioAccountSid,
  twilioApiKeySid,
  twilioAuthToken,
};

export interface SecretMatch {
  type: SecretType;
  match: string;
  index: number;
}

export type SecretType =
  // Anthropic
  | 'anthropicApiKey'
  // AWS
  | 'awsAccessKeyId'
  | 'awsSecretAccessKey'
  | 'awsAccountId'
  // Azure
  | 'azureClientId'
  | 'azureClientSecret'
  // Basic Auth
  | 'basicAuthUrl'
  | 'basicAuthHeader'
  // GitHub
  | 'githubPersonalAccessToken'
  | 'githubOAuthToken'
  | 'githubAppToken'
  | 'githubRefreshToken'
  | 'githubFineGrainedToken'
  // Google
  | 'googleApiKey'
  | 'googleOAuthToken'
  | 'googleServiceAccountKey'
  | 'googleServiceAccountEmail'
  // NPM
  | 'npmAccessToken'
  | 'npmAuthToken'
  | 'npmTokenEnv'
  // OpenAI
  | 'openaiApiKey'
  // Private Keys
  | 'rsaPrivateKey'
  | 'privateKey'
  | 'ecPrivateKey'
  | 'dsaPrivateKey'
  | 'opensshPrivateKey'
  | 'pgpPrivateKey'
  | 'encryptedPrivateKey'
  // SendGrid
  | 'sendgridApiKey'
  // Shopify
  | 'shopifyToken'
  // Slack
  | 'slackBotToken'
  | 'slackUserToken'
  | 'slackWorkspaceToken'
  | 'slackAppToken'
  | 'slackWebhook'
  | 'slackLegacyToken'
  // Stripe
  | 'stripeSecretKey'
  // Twilio
  | 'twilioAccountSid'
  | 'twilioApiKeySid'
  | 'twilioAuthToken'
  // Generic patterns
  | 'envCredential'
  | 'jwtToken';
